module.exports = __webpack_public_path__ + "img/001.cf0bb9af.png";